module.exports = __webpack_public_path__ + "img/defaultCoinIco.62e00738.png";